<template>
  <!-- 活动管理 -->
  <div>
    <div class="activityManage">
      <!-- 头部表单查询 -->
      <el-form ref="form" class="formClass" :model="recordData" label-position="right" :label-width="recordData.activityType==33?'160px':'120px'">
        <el-form-item label="活动名称：">
          <el-input placeholder="请输入活动名称" size="small" v-model="recordData.activityName"></el-input>
        </el-form-item>
        <el-form-item label="活动时间：">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="recordData.startTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 126px; font-size: 12px"
              class="time1"
            >
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="recordData.endTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="time2"
              style="width: 140px; font-size: 12px"
              :clearable="false"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="(recordData.startTime = ''), (recordData.endTime = '')"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
        </el-form-item>

        <el-form-item label="活动状态：">
          <el-select v-model="recordData.status" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="未开始" :value="1"></el-option>
            <el-option label="进行中" :value="2"></el-option>
            <el-option label="已结束" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="最后修改时间：">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="recordData.startUpdateTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              style="width: 126px; font-size: 12px"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="time1"
            >
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="recordData.endUpdateTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              style="width: 140px; font-size: 12px"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="time2"
              :clearable="false"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="(recordData.endUpdateTime = ''), (recordData.startUpdateTime = '')"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
        </el-form-item>

        <el-form-item label="是否在积分商城显示：" v-if="recordData.activityType==33" label-width="160px">
          <el-select v-model="recordData.isDisplay" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <div class="seach_btn">
          <el-button size="small" class="search" @click="queryListBtn()">
            查询
          </el-button>
          <el-button size="small" class="reset" @click="handleReset">重置</el-button>
        </div>
      </el-form>
      <div class="point-btn" v-if="recordData.activityType==33">
        <el-button style="width: auto;" size="small" class="search" @click="handleToDecoration">积分商城装修</el-button>
      </div>
      <!-- recordData.activityType -->
      <!-- 表格内容 -->
      <el-table
        :data="activityList"
        v-loading="talbeLoading"
        style="width: 100%; margin-top: 20px"
        ref="table"
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template slot="empty">
          <div>
            <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column label="活动名称" width="280" prop="activityName"></el-table-column>

        <el-table-column label="活动类型">
          <template slot-scope="scope">
            <span> {{ activityName(scope.row.activityType) }} </span>
          </template>
        </el-table-column>

        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <div class="activityTime">
              <span>起: {{ scope.row.startTime }}</span>
              <span>止: {{ scope.row.endTime }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最后修改时间" prop="updateTime"> </el-table-column>
        <el-table-column label="活动状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="state y1">未开始 </span>
            <span v-if="scope.row.status == 2" class="state y2">进行中 </span>
            <span v-if="scope.row.status == 3" class="state y3">已结束 </span>
            <el-tooltip v-if="scope.row.activityType == 35 && scope.row.status == 3 && scope.row.reason" class="end-reason" effect="light" :content="scope.row.reason" placement="bottom">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="isDisplay" width="140" v-if="recordData.activityType==33">
          <template #header>
            <span>是否在商城显示</span>
            <el-tooltip class="item" effect="light" content="开启后，会在积分商场列表显示" placement="top">
              <i class="el-icon-question" style="margin: -2px 2px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isDisplay"
              active-color="#49C568"
              :active-value="1"
              :inactive-value="0"
              @change="handleChangeDisplayOrSort($event, scope.row,'isDisplay')"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="sort" width="160" v-if="recordData.activityType==33">
          <template #header>
            <span>展示优先级</span>
            <el-tooltip class="item" effect="light" content="数字越小优先级越高，展示在越前面，优先级相同时，按最后修改时间最近优先展示；" placement="top">
              <i class="el-icon-question" style="margin: -2px 2px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.sort" @change="handleChangeDisplayOrSort($event, scope.row,'sort')" :min="1"></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <div class="editList">
              <span @click="extension(scope.row)" class="edit">
                推广
              </span>
              <span @click="modify(scope.row.activityType, scope.row, 'look')" class="edit">
                查看
              </span>
              <!-- <span v-if="scope.row.status == 1" @click="modify(scope.row.activityType, scope.row)" class="edit">
                修改
              </span> -->
              <template v-if="scope.row.activityType == 35">
                <span v-if="scope.row.status == 1" @click="modify(scope.row.activityType, scope.row,'edit')" class="edit">
                  修改
                </span>
                <span v-else>-</span>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1 || scope.row.status == 2 " @click="modify(scope.row.activityType, scope.row,'edit')" class="edit">
                  修改
                </span>
                <span v-if="scope.row.status == 3">-</span>
              </template>
              <span v-if="scope.row.status == 2" @click="endenActivity(scope.row.id)" class="end">结束</span>
              <span @click="statisData(scope.row)" class="count">数据统计</span>
              <span @click="modify(scope.row.activityType, scope.row, 'copy')" class="edit">复制</span>
              <span @click="deleteActivity(scope.row)" class="delete">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="recordData.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="recordData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        class="pagination"
      >
      </el-pagination>
    </div>

    <!-- 结束活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否结束活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisibleTwo" width="400px" :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 活动推广 -->
    <el-dialog title="活动推广" :modal-append-to-body="false" :visible.sync="CodeVisible" width="800px">
      <div class="activityName">
        <p style="margin-bottom: 20px;text-align: center;">
          请用手机淘宝APP扫描下面二维码查看您店铺的活动详情
        </p>
        <div class="qrcode" id="qrcodebox" ref="qrcodebox" style="width: 300px;height: 300px;margin: 0 auto;"></div>
        <div style="width: 375px;margin: 0 auto;">
          <p style="margin: 20px 0;text-align: center;">
            访问链接:(用于装修到店铺的链接)
          </p>
          <el-input readonly v-model="coodeItem.activityUrl" style="margin: 0 20px; width: 220px"></el-input
          ><el-button type="primary" v-clipboard:copy="coodeItem.activityUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
            >复制</el-button
          >
        </div>
        <div class="activityName_line"></div>
        <div class="activityName_title">可通过以下方式推广活动</div>
        <div class="activityName_bottom">
          <div class="activityName_bottom_content">
            <span class="activityName_bottom_wz">直播动态部件</span>
            <div class="display:flex">
              <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
              <span class="activityName_bottom_tg" @click="handlejc(1)">去推广</span>
            </div>
          </div>
          <div class="activityName_bottom_content">
            <span class="activityName_bottom_wz">直播模块装修</span>
            <div class="display:flex">
              <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
              <span class="activityName_bottom_tg" @click="handlejc(2)">去推广</span>
            </div>
          </div>
          <div class="activityName_bottom_content">
            <span class="activityName_bottom_wz">手淘首页海报装修</span>
            <div class="display:flex">
              <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
              <span class="activityName_bottom_tg" @click="handlejc(3)">去推广</span>
            </div>
          </div>
          <div class="activityName_bottom_content">
            <span class="activityName_bottom_wz">手淘详情页装修</span>
            <div class="display:flex">
              <span class="activityName_bottom_jc pointer" @click="handlejc(5)">看教程</span>
              <span class="activityName_bottom_tg pointer" @click="handlejc(4)">去推广</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="CodeVisible = false">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import statistics from "../integralCenter/activity_data_statistics";
import { queryActivity, endEvent, deleteEvent, updateActivity } from "@/api/activityController";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
export default {
  components: {
    statistics,
  },
  data() {
    return {
      coodeItem: {
        activityUrl: "",
      },
      isCopy: false,
      copyParams: {},
      isStartEdit:false,
      startEditParams:{},
      CodeVisible: false,
      actManag: 1,
      backgroundOpacity: false,
      statusComment: false,
      isSave: true,
      pageName: "忠诚度管理-积分-活动管理",
      talbeLoading: false,
      qrcode: null,
      outerVisible: false,
      outerVisibleTwo: false,
      valueRow: {},
      createVal: 0,
      activityDataTwo: {
        telImg: require("../../assets/images/integralCenter/night_m.png"),
        telCode: require("../../assets/images/integralCenter/code.png"),
        id: 1,
        name: "大转盘抽奖",
      },
      activityData: {},
      createStep: 1,
      activityList: [],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
        startTime: "",
        activityName: "",
        endTime: "",
        startUpdateTime: "",
        endUpdateTime: "",
        status: "",
        activityType: -1,
        isDisplay: ""
      },
      rowData: {},
      ids: "",
      ids1: "",
      activityUrl: "",
      venderId: "",
      aaa: "",
      status: 1,
      mytimestart: "",
      mytimeend: "",
      opentime: true,
    };
  },

  created() {
    console.log(this.$route.query, 9999999);
    let activityType = this.$route.query.activityType;
    this.recordData.activityType = this.$route.query.activityType * 1;
    if (this.recordData.activityType * 1 < 8 && this.recordData.activityType * 1 > 1)
      this.recordData.activityType = this.$route.query.activityType * 1 + 1;
    if (activityType == 16 || activityType == 17 || activityType == 18 
    || activityType == 19 || activityType == 31 || activityType == 32 
    || activityType == 33 || activityType == 34 || activityType == 35 || activityType == 37) this.actManag = 2;
    if (activityType == 8) this.actManag = 4;
    if (activityType == 23 || activityType == 24) this.actManag = 3;
    this.queryList();
    // this.time();
    // this.prefixQue();
  },

  methods: {
    handlejc(type) {
      if (type == 1) {
        window.open(
          "https://market.m.taobao.com/app/taefed/shopping-delivery-wapp/index.html#/putin?tabKey=all&appId=3000000075963142&spm=a21dvs.27050869.0.27050869.311514a0Av8jPb",
          "_blank"
        );
      }
      if (type == 2) {
        window.open(
          "https://market.m.taobao.com/app/taefed/shopping-delivery-wapp/index.html#/putin?tabKey=all&appId=3000000075963142&spm=a21dvs.27050869.0.27050869.311514a0Av8jPb",
          "_blank"
        );
      }
      if (type == 3) {
        window.open("https://myseller.taobao.com/home.htm/mobiledecorate", "_blank");
      }
      if (type == 4) {
        window.open("https://ecrm.taobao.com/p/member/memberDecorateLightShop.htm#/", "_blank");
      }
      if (type == 5) {
        window.open("https://www.yuque.com/docs/share/96cfa344-785f-4a43-8ffe-3bdd19e44d78?#", "_blank");
      }
    },
    handleReset() {
      this.recordData.startTime = "";
      this.recordData.endTime = "";
      this.recordData.startUpdateTime = "";
      this.recordData.endUpdateTime = "";
      this.recordData.status = "";
      this.recordData.activityName = "";
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.queryList();
    },
    activityName(type) {
      let arr = ["", "签到赢好礼", "浏览礼品有礼", "每日抢好礼", "关注店铺有礼", "邀请开卡有礼", "邀请关注店铺有礼", "完善信息有礼", "大转盘抽奖"];
      let arr1 = [
        "开卡礼包",
        "店铺礼包",
        "店铺礼包（千人千面）",
        "下单有礼",
        "首购有礼",
        "复购有礼",
        "下单抽奖",
        "评价有礼",
        "裂变神券",
        "天降红包雨",
        "疯狂捉娃娃",
        "大家来找茬",
        "入会打榜",
        "幸运抽奖",
        "0元试用",
        "智能海报",
        "刮刮乐",
        "0元试用",
        "调查问卷",
        "生日有礼",
        "积分兑换",
        "满额有礼",
        "下单冲榜",
        "会员升级礼"
      ];
      let arr2 = ['会员升级礼']
      if(type == 37) return arr2[0];
      if (type < 9) return arr[type];
      if (type > 12) return arr1[type - 13];
    },
    extension(val) {
      this.CodeVisible = true;
      this.coodeItem.activityUrl = val.activityUrl;
      this.$nextTick(() => {
        this.$refs.qrcodebox.innerHTML = "";
        this.qrcodeAll(val.activityUrl, "qrcodebox");
      });
    },
    //时间拼装
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.mytimestart = `${this.getDateStr(-30)} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.$store.state.venderId = res.data.venderId;
          console.log(this.recordData);
          // this.queryList();
          this.$refs.inputForm.formSearch();
        })
        .catch((res) => {});
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              if(this.activityList.length == 1 && this.recordData.current !=1){
                this.recordData.current = this.recordData.current-1;
              }
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    returnStep() {
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.prefixQue();
      // console.log(this.recordData,99988);
    },
    createActivity(type) {
      if (type == 5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡",
          telImg: require("../../assets/images/integralCenter/kk.jpg"),
          telCode: this.idUrl5,
        };
        return;
      }
      if (type == 16 || type == 17 || type == 18) {
        this.createStep = 16;
        switch (type) {
          case 16:
            this.activityData = {
              id: 16,
              name: "下单有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "下单有礼";
            break;
          case 17:
            this.activityData = {
              id: 17,
              name: "首购有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "首购有礼";
            break;
          case 18:
            this.activityData = {
              id: 18,
              name: "复购有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "复购有礼";
            break;
        }
        return;
      }
      if (type == 20 || type == 21 || type == 22) {
        this.createStep = 20;
        switch (type) {
          case 20:
            this.activityData = {
              id: 20,
              name: "评价有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "评价有礼";
            break;
          case 21:
            this.activityData = {
              id: 21,
              name: "裂变神券",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "裂变神券";
            break;
          case 22:
            this.activityData = {
              id: 22,
              name: "天降红包雨",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "天降红包雨";
            break;
        }
        return;
      }
      if (type == 15) {
        this.createStep = 15;
        this.activityData = {
          id: 15,
          name: "店铺礼包千人千面",
          telImg: require("../../assets/images/integralCenter/dingzhi.png"),
          telCode: "",
        };
        this.titleName = "店铺礼包千人千面";
        return;
      }
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "日历签到",
            telImg: require("../../assets/images/integralCenter/qdq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日抢好礼",
            telImg: require("../../assets/images/integralCenter/mrq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../assets/images/integralCenter/gzdp.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡",
            telImg: require("../../assets/images/integralCenter/kk.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注店铺",
            telImg: require("../../assets/images/integralCenter/yqgz.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../assets/images/integralCenter/wsxx.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      this.changeStatus();
      this.prefixQue();
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.changeStatus();
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },
    //活动管理查询
    queryList() {
      if (sessionStorage.getItem("goBack")) sessionStorage.removeItem("goBack");
      this.talbeLoading = true;
      this.recordData.mainType = this.actManag;
      // if (this.actManag == 3) {
      //   if (this.titlName == "疯狂抓娃娃") this.recordData.activityType = 23;
      //   if (this.titlName == "大家来找茬") this.recordData.activityType = 24;
      // }
      // if (this.actManag == true) {
      //   this.recordData.mainType = 2;
      // } else {
      //   this.recordData.mainType = 1;
      // }

      // this.activityList.forEach((item, index) => {
      //   var ref = "qrcode" + item.id;
      //   // console.log( this.$refs[ref])
      //   this.$refs[ref].innerHTML = "";
      // });
      this.talbeLoading = true;
      if (this.opentime == true) {
        this.opentime = false;
      }
      queryActivity({ ...this.recordData, status: this.recordData.status == 0 ? "" : this.recordData.status })
        .then((res) => {
          this.talbeLoading = false;
          this.activityList = res.data.records;
          // let arr = [{activityType:31,status:1,id:1},{activityType:31,status:2,id:2},{activityType:31,status:3,id:3}]
          // this.activityList = [...arr]
          this.totalNum = Number(res.data.total);
        })
        .catch(() => {});
    },
    //大转盘管理查询

    // 表单查询
    searchForm(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log("form:", this.recordData);
      this.queryList();
    },

    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.queryList();
    },

    //查询按钮
    queryListBtn(){
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.queryList();
    },

    //结束活动
    endenActivity(id) {
      // console.log(123);
      this.outerVisible = true;
      this.ids = id;
    },

    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //修改

    modify(row, val, type = "edit") {
      // type==edit 为修改
      this.backgroundOpacity = type == "look" ? true : false;
      this.isCopy = type == "copy" ? true : false;

   

      // 进行中的活动  去掉保存按钮
      // 活动进行中 可以修改 活动名称、活动结束时间、活动奖品数量（只可增加，不可减少）、活动规则、曝光商品
      if (val.status == 2 && type == "edit") {
        this.isStartEdit = true;
        this.isSave = true;
      }else if  (val.status == 1) {
        this.isStartEdit = false;
        this.isSave = true;
      }else {
        this.isStartEdit = false;
        this.isSave = false;
      }
      // 评价有礼 修改禁用一些输入框
      this.statusComment = false;
      if (row == 20) {
        this.isSave = false;
        if (val.status == 2) {
          this.statusComment = false;
        } else {
          this.statusComment = true;
        }
      }
      let params = {
        activityData: {
          name: this.activityName(row),
          id: row > 1 && row < 8 ? row - 1 : row,
          telCode: "",
          goIndex: 1,
        },
        valueRow: {
          id: val.id,
        },
        statusComment: this.statusComment,
        isSave: this.isSave,
        isStartEdit:this.isStartEdit,
        backgroundOpacity: this.backgroundOpacity,
        activeValue: row,
        activityType: row > 1 && row < 8 ? row - 1 : row,
      };
      if (this.isCopy) {
        this.copyParams = params
        this.$emit("copy", this.copyParams)
        return 
      }
      if (row == 8) {
        this.$router.push({ path: "step", query: params });
      } else if (row == 19) {
        this.$router.push({ path: "step2", query: params });
      } else if (row == 23 || row == 24) {
        this.$router.push({ path: "games", query: params });
      } else if (row == 5) {
        this.$router.push({ path: "Invites", query: params });
      } else if (row == 16 || row == 17 || row == 18) {
        this.$router.push({ path: "polite", query: params });
      } else if (row == 20 || row == 21 || row == 22) {
        this.$router.push({ path: "evaluation", query: params });
      }else if(row == 25){
        this.$router.push({ path: "games", query: params });
      } else if(row == 26){
        this.$router.push({ path: "luckyDraw", query: params });
      } else if(row == 27){
        this.$router.push({ path: "trial", query: params });
      } else if(row == 31){
        this.$router.push({ path: "question", query: params });
      } else if(row == 32){
        this.$router.push({ path: "birthday", query: params });
      } else if(row == 33){
        this.$router.push({ path: "exchange", query: params });
      } else if(row == 34){
        this.$router.push({ path: "fulfilQuotaPage", query: params });
      }else if(row == 35){
        this.$router.push({ path: "orderRankPage", query: params });
      } else if(row == 37){
        this.$router.push({ path: "memberUpgrade", query: params });
      } else {
        this.$router.push({ path: "activity", query: params });
      }
    },
    changeStatus() {
      this.$emit("changeStatus");
    },
    //数据统计
    statisData(row) {
      let params = {
        row: row,
        id: row.id,
        createStep: 3,
      };
      this.$emit("handleshow", params);
      // this.rowData = row;
      // this.ids1 = row.id;
      // this.createStep = 3;
    },
    handleback(type) {
      this.$emit("goback", type);
    },
    handleToDecoration() {
      let params = {
        isShowIntegral: true,
        createStep: "decoration",
      };
      this.$emit("handleshow", params);
    },
    // 是否在商城显示/优先级
    async handleChangeDisplayOrSort(val,row,flag) {
      if(flag=='sort') {
        if(!val) {
          row.sort = '1'
         return this.$message.warning("优先级输入不能为空")
        }
      }
      let params = {
        id:row.id
      }
      if(flag=="isDisplay") {
        params.isDisplay = val
        params.sort = row.sort || 1
      } else {
        params.sort = val
        params.isDisplay = row.isDisplay
      }
      try {
        const res = await updateActivity(params)
        if(res.code==1) {
          this.$message.success(res.message)
          this.queryList();
        }
      } catch (error) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.end-reason{
  color: #ccc;
  margin-left: 10px;
  cursor: pointer;
}
.formClass {
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  /deep/.el-form-item {
    width: 33.3%;
  }
  @media screen and (max-width: 1558px) {
    /deep/.el-form-item {
      width: 50%;
    }
  }
  @media screen and (max-width: 1145px) {
    /deep/.el-form-item {
      width: 70%;
    }
  }
  .seach_btn {
    display: flex;
    margin-left: 40px;
  }
  .search,
  .reset {
    width: 98px;
    font-size: 14px;
    height: 32px;
    transition: all 0.2s;
    border-radius: 4px 4px 4px 4px;
  }
  .search {
    color: #fff;
    background-color: #2670fb;
    &:hover {
      opacity: 0.8;
    }
  }
  .reset {
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #2670fb;
      border: 1px solid #2670fb;
      background: rgba(38, 112, 251, 0.1);
    }
  }
}
.point-btn {
  text-align: right;
  .search {
    color: #fff;
    background-color: #2670fb;
    &:hover {
      opacity: 0.8;
    }
  }
}
.createbox {
  width: 94px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #2670fb;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  color: #fff;
  background-color: #2670fb;
  &:hover {
    opacity: 0.8;
  }
}
.topbox {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
  &-back {
    padding: 8px 15px;
    border: 1px solid #2670fb;
    margin-right: 10px;
    color: #2670fb;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: #fff;
      background-color: #2670fb;
    }
  }
}
.activityManage {
  box-sizing: border-box;
  .activityName {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    .code {
      cursor: pointer;
      font-size: 14px;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .state {
    padding: 5px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #02b1ff;
    background: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      min-width: 28px;
      cursor: pointer;
    }
    .end,
    .edit,
    .count {
      cursor: pointer;
      color: #2670fb;
      &:hover {
        color: #2670fb;
      }
    }
    .delete {
      cursor: pointer;
      color: red;
      text-align: center;
      // &:hover {
      //   color: #2670fb;
      // }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
    &:active {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #2670fb;
    color: #ffffff;
    border-radius: 3px;
    background-color: #2670fb;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #2670fb;
    }
    &:active {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
  }
}

.activityName_line {
  width: 95%;
  height: 0px;
  border-top: 1px solid #ccc;
  margin-top: 29px;
}
.activityName_title {
  background: #fff;
  padding: 10px 15px 10px 0;
  margin-top: -20px;
  font-size: 16px;
  width: 207px;
}
.activityName_bottom {
  width: 100%;
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
  flex-wrap: wrap;
  &_content {
    width: 48%;
    margin-bottom: 24px;
    background: #f8f9ff;
    display: flex;
    justify-content: space-between;
    padding: 15px 10px;
  }
  &_jc {
    background: #fff;
    border: 1px solid #dddddd;
    padding: 5px 8px;
    margin-left: 8px;
    cursor: pointer;
  }
  &_tg {
    background: #2670fb;
    color: #fff;
    border: 1px solid #2670fb;
    padding: 5px 8px;
    margin-left: 8px;
    cursor: pointer;
  }
}
// .activityManage/deep/.el_btn {
// display: inline-block;
// }
</style>
